import React from 'react'
import { observer } from 'mobx-react'
import classnames from 'classnames'
import Icon from './Icon'
import _ from 'lodash'

const Toggle = ({ icon, label, enabled, onClick, extraClasses, title }) => (
  <div
    onClick={onClick}
    title={title && title}
    className={classnames({ toggle: true, enabled }, extraClasses)}
  >
    <Icon id={icon} />
    {_.isEmpty(label) ? null : <span>{label}</span>}
  </div>
)

export default observer(Toggle)
